import { Checkbox, Flex, P } from '@dnb/eufemia';

import { capitalizeFirstLetterOfString } from '@/utils/textUtils';

export const STAGE_FILTER_KEY = 'stage';

type StageOption = { selectedKey: string; content: string[] };
type Props = {
  stageCounts: Record<string, number>;
  stageOptions: StageOption[];
  selectedStages: string[];
  updateFilterInURL: (key: string, values: string[], options: StageOption[]) => void;
};

export default function StageFilter({ stageCounts, stageOptions, selectedStages, updateFilterInURL }: Props) {
  const handleChange = (stage: string, checked: boolean) => {
    const newStages = checked ? [...selectedStages, stage] : selectedStages.filter((s) => s !== stage);
    updateFilterInURL(STAGE_FILTER_KEY, newStages, stageOptions);
  };

  // Desired order for stages
  const stageOrder = ['upcoming', 'launched', 'deprecated', 'decommissioned'];
  const sortedStageOptions = [...stageOptions].sort(
    (a, b) => stageOrder.indexOf(a.selectedKey) - stageOrder.indexOf(b.selectedKey),
  );

  return (
    <Flex.Vertical top="medium">
      <P space={{ bottom: 'x-small' }} weight="medium">
        Stage
      </P>
      {sortedStageOptions.map(({ selectedKey }) => (
        <Checkbox
          checked={selectedStages.includes(selectedKey)}
          key={selectedKey}
          label={`${capitalizeFirstLetterOfString(selectedKey)} (${stageCounts[selectedKey] ?? 0})`}
          onChange={({ checked }) => handleChange(selectedKey, checked)}
          size="medium"
          space={{ top: 'xx-small', bottom: 'xx-small' }}
        />
      ))}
    </Flex.Vertical>
  );
}
